import React, { useEffect, useState } from "react";
import axios from "axios";
import { api_path } from "../../shared.js";

export default function AssetSummaryPage({
  onStageClick,
  userId,
  salesId,
  datefrom,
  dateto,
  salesTeam,
  salesRole,
}) {
  const [summary, setSummary] = useState([]);
  const [selectedStage, setSelectedStage] = useState(null);
  const url = `${api_path}/customer/get-activitySummary_2.php?userId=${userId}&salesId=${salesId}&datefrom=${datefrom}&dateto=${dateto}&salesTeam=${salesTeam}&salesRole=${salesRole}`;

//   useEffect(() => {
//     axios.get(url).then((res) => {
//       setSummary(res.data);
//     });
//   }, [userId,salesId, datefrom, dateto]);

  const handleClick = (stage) => {
    const newStage =
      selectedStage && selectedStage === stage ? null : stage?.trim() || null;
    setSelectedStage(newStage);
    if (typeof onStageClick === "function") {
      onStageClick(newStage);
    }
  };

 // สีพื้นหลังแต่ละสถานะ
const stageColors = {
  "In Use": "#e7f5ff",            // ฟ้าอ่อน
  "Available": "#e6fcf5",         // เขียวมิ้นต์
  "In Repair": "#fff4e6",         // ส้มอ่อน
  "Retired": "#f1f3f5",           // เทาอ่อน
  "Lost": "#ffe3e3",              // แดงอ่อน
  "Pending Assignment": "#f8f0fc" // ม่วงอ่อน
};

// สีเส้นขอบ
const borderColors = {
  "Active": "#20c997",         // เขียวมิ้นต์เข้ม
  "Expire Soon": "#f08c00",         // ส้มเข้ม
   "Expired": "#e03131",
  "Grace Period": "#ae3ec9" // ม่วงเข้ม
};

// สีตัวอักษร
const fontColors = {
  "Active": "#20c997",
    "Expire Soon": "#f08c00",         // ส้มเข้ม
  "Expired": "#e03131",
  "Grace Period": "#ae3ec9"
};

  const assetStatusSummary = [
  {
    ID: 1,
    STATUS_NAME: "Active",
    TOTAL: 1210
  },
  {
    ID: 2,
    STATUS_NAME: "Expire Soon",
    TOTAL: 50
  },
  {
    ID: 3,
    STATUS_NAME: "Expired",
    TOTAL: 35
  },
  {
    ID: 4,
    STATUS_NAME: "Grace Period",
    TOTAL: 12
  }
];
useEffect(() => {
  // simulate API
  setTimeout(() => {
    setSummary(assetStatusSummary);
  }, 300);
}, []);
  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 10,
        marginBottom: 20,
        justifyContent: "center",
        width: "100%",
      }}
    >
      {Array.isArray(summary) && summary.length > 0 ? (
        summary.map((item) => {
          const bgColor = "#fff";
          const textColor =
            selectedStage === item.STATUS_NAME
              ? fontColors[item.STATUS_NAME]
              : "#2b2b2bff";

          return (
            <div
              key={item.ACTIVITY_ID}
              onClick={() => handleClick(item.ACTIVITY_ID)}
              style={{
                flex: "1 1 120px",
                border:
                  selectedStage === item.STATUS_NAME
                    ? `2px solid ${
                        borderColors[item.STATUS_NAME] || "#0078d4"
                      }`
                    : `1px solid ${borderColors[item.STATUS_NAME] || "#ccc"}`,
                borderRadius: 12,
                padding: 16,
                textAlign: "center",
                cursor: "pointer",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                backgroundColor: bgColor,
                color: textColor,
                transition: "0.2s",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: 18 }}>
                {item.TOTAL}
              </div>
              <div>{item.STATUS_NAME}</div>
            </div>
          );
        })
      ) : (
        <div style={{ color: "#888" }}>ไม่มีข้อมูล</div>
      )}
    </div>
  );
}
